export default __webpack_public_path__ + "static/media/ask_a_doc.fbe1bbfe.png";